import { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { logout } from '../store';

export const Logout: FC = () => {
  logout();

  return <Redirect to="/" />;
};
